// 261010 P8b-2 — hero bảng cấp tập (thuần: không antd/router). Chặng n/3 + chip engine + tên plan.
import type { WorkflowPlanInfo, WorkflowStatus } from '../../types/filmWorkflow';
import { isDoneState, planProgress } from './workflowBoardUtils';

export const STAGE_NAME: Record<1 | 2 | 3, string> = {
  1: 'Phân đoạn',
  2: 'Đạo diễn ⇒ Quay phim',
  3: 'Từ Sơ đồ, bạn bấm',
};

export function currentStageOf(status: Pick<WorkflowStatus, 'jobs' | 'steps' | 'events' | 'gates'>): 1 | 2 | 3 {
  const job = (status.jobs ?? []).find((x) => x.type === 'FILM_WORKFLOW_RUN');
  if (job?.phase === 'stage-1') return 1;
  if (job?.phase === 'stage-2') return 2;
  const script = status.steps.find((s) => s.key === 'SCRIPT')?.state ?? 'NOT_READY';
  if (script !== 'READY' && script !== 'APPROVED') return 1;
  if (status.gates && script === 'READY') return 1;
  const events = status.events ?? [];
  const undone = (key: 'DIRECTING' | 'CINEMATOGRAPHY') => events.some((e) => !isDoneState(e.steps?.[key] ?? 'NOT_READY'));
  if (undone('DIRECTING') || undone('CINEMATOGRAPHY')) return 2;
  return 3;
}

/** «0/15 video có clip · 0/8 bước xong · Seedance 2.5» → «0/15 clip · 0/8 bước · Seedance 2.5» (hàng trên cùng gọn). */
export const compactSummaryOf = (line: string): string => line.replace(' video có clip', ' clip').replace(' bước xong', ' bước');

export function engineChipOf(engines?: WorkflowPlanInfo['engines'] | null): string | null {
  if (!engines) return null;
  const a = engines.SEEDANCE_20 || 0;
  const b = engines.SEEDANCE_25 || 0;
  if (a === 0 && b === 0) return null;
  if (a > 0 && b === 0) return 'Seedance 2.0';
  if (b > 0 && a === 0) return 'Seedance 2.5';
  return `2.0 × ${a} · 2.5 × ${b}`;
}

export function planDisplayName(plan: { name?: string } | null | undefined, detailName: string | null | undefined, planId: string): string {
  const n = String(plan?.name ?? '').trim();
  if (n) return n;
  const d = String(detailName ?? '').trim();
  if (d) return d;
  return planId ? `Plan ${planId.slice(0, 8)}` : 'Plan';
}

export function heroViewOf(status: WorkflowStatus, detailName: string | null | undefined, planId: string): {
  name: string; engineChip: string | null; withClip: number; total: number; stage: 1 | 2 | 3; stageName: string; progressPct: number;
} {
  const stage = currentStageOf(status);
  const prog = planProgress(status.steps);
  return {
    name: planDisplayName(status.plan, detailName, planId),
    engineChip: engineChipOf(status.plan?.engines),
    withClip: prog.withClip,
    total: prog.total,
    stage,
    stageName: STAGE_NAME[stage],
    progressPct: prog.total ? (prog.withClip / prog.total) * 100 : 0,
  };
}
